import { render, staticRenderFns } from "./ApexChart.vue?vue&type=template&id=35c2233d&"
import script from "./ApexChart.vue?vue&type=script&lang=js&"
export * from "./ApexChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports